export default __webpack_public_path__ + "static/media/languages-web-coding.eb2d6bc6.png";